import React from "react";
import { Col, Container, Row } from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import AuthLogo from "../../Components/Auth/AuthLogo";
import AuthCard from "../../Components/Auth/AuthCard";
import AuthContainer from "../../Components/Auth/AuthContainer";
import { GlobalImage } from "config/image";

const ViewStatus = () => {
  document.title = "EaziQuote";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <AuthContainer>
          <Container>
            <Row>
              <Col lg={12}>
                <AuthLogo />
              </Col>
            </Row>

            <Row className="auth-container">
              <Col md={8} lg={6} xl={5}>
                <AuthCard>
                  <div className="text-center mt-2">
                    <img
                      src={GlobalImage.successTick}
                      alt="Success"
                      width={45}
                      className="mb-3"
                    />

                    <h5 className="font-primary fs-24 text-black2D  fw-semibold  ">
                      Thank You 🎉
                    </h5>
                    <p className="font-primary fs-19 text-grey89 fw-normal mt-3">
                      Your response has been received successfully.
                      <br />
                      We will contact you shortly.
                    </p>
                  </div>
                </AuthCard>
              </Col>
            </Row>
          </Container>
        </AuthContainer>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default ViewStatus;
